import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import './styles/aac-tokens.css';
import App from './App';
import { AccessibilityProvider } from './contexts/AccessibilityContext';

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
      })
      .catch((registrationError) => {
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AccessibilityProvider>
    <App />
  </AccessibilityProvider>
);

// Report web vitals for performance monitoring
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

reportWebVitals();
